import Layout from "@/layout";

const supplierRouter = {
    path: "/supplier",
    component: Layout,
    redirect: "/supplier/supplierManagement",
    name: "Supplier",
    alwaysShow: true,
    meta: {
        title: "供应商管理",
        icon: "bizOrder",
    },
    children: [
        {
            path: "/supplier/supplierManagement",
            name: "SupplierManagement",
            component: () => import("@/views/supplier/supplierManagement/index.vue"),
            meta: {
                title: "供应商列表",
            },
        },
        {
            path: "/supplier/supplierContract",
            name: "SupplierContract",
            component: () => import("@/views/supplier/supplierContract/index.vue"),
            meta: {
                title: "供应商合同",
            },
        },
        {
            path: "/supplier/contractSealing",
            name: "ContractSealing",
            component: () => import("@/views/supplier/contractSealing/index.vue"),
            meta: {
                title: "合同用印",
            },
        },
        {
            path: "/supplier/supplierOrder",
            name: "supplierOrder",
            component: () => import("@/views/supplier/supplierOrder/index.vue"),
            meta: {
                title: "供应商订单",
            },
        },
        {
            path: "/supplier/orderSealing",
            name: "OrderSealing",
            component: () => import("@/views/supplier/orderSealing/index.vue"),
            meta: {
                title: "订单用印",
            },
        },
    ],
};

export default supplierRouter;
